@if (overlayType != overlayTypeEnum.NONE) {
  <div class="overlay-legend-container" [class.va-open]="overlayType === overlayTypeEnum.VISUAL_ANALYSIS">
    <div class="overlay-legend-wrapper">
      @for (item of legendItems; track item) {
        <div class="legend-item gap-2 d-flex justify-content-start align-items-center"
             (mouseenter)="onMouseEnter(item)"
             (mouseleave)="onMouseLeave()">
          <span class="legend-color" [style.background]="item.color"></span>
          <span class="legend-title">{{ item.text }}</span>
        </div>
      }
    </div>
  </div>
}